export default __webpack_public_path__ + "static/media/t3d-company-logo.0a2b6a2e.svg";